import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface PageReadyContextValue {
  pageReady: boolean;
  setPageReady: (ready: boolean) => void;
}

const PageReadyContext = createContext<PageReadyContextValue>({
  pageReady: true,
  setPageReady: () => {},
});

export const PageReadyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Default to true so pages that don't fetch data (LoginPage, BasketPage, etc.)
  // don't get stuck behind the loader. Pages that DO fetch (HomePage, ContentPage)
  // call setPageReady(false) in a useLayoutEffect before paint, then setPageReady(true)
  // once the data is in — eliminating CLS without flashing a partial layout.
  const [pageReady, setPageReadyState] = useState(true);
  const setPageReady = useCallback((ready: boolean) => {
    setPageReadyState(ready);
  }, []);
  return (
    <PageReadyContext.Provider value={{ pageReady, setPageReady }}>
      {children}
    </PageReadyContext.Provider>
  );
};

export const usePageReady = (): PageReadyContextValue => useContext(PageReadyContext);
